import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Button } from 'react-bootstrap';
import CardsData from './cardsData.js'; // Import the updated card data

const Cards = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const cardsPerPage = 6;

    const filteredCards = CardsData.filter(card =>
        (card.name && card.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (card.address && card.address.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (card.phone && card.phone.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const sortedCards = filteredCards.sort((a, b) => b.id - a.id);

    const indexOfLastCard = currentPage * cardsPerPage;
    const indexOfFirstCard = indexOfLastCard - cardsPerPage;
    const currentCards = sortedCards.slice(indexOfFirstCard, indexOfLastCard);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    const paginate = pageNumber => setCurrentPage(pageNumber);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }, [currentPage]);

    return (
        <Card className="bottom-radius-15 text-light bg-black mb-4">
            <Card.Body>
                <Row className="mb-3">
                    <Col>
                        <h1 className="text-light">Cards</h1>
                    </Col>
                    <Col><div><a href="/contact" className='btn btn-secondary'>Add Card</a></div></Col>
                    <Col>
                        <input
                            type="text"
                            placeholder="Search cards by keyword"
                            value={searchTerm}
                            onChange={handleSearch}
                            className="bg-dark-subtle shadow form-control"
                        />
                    </Col>
                </Row>

                <Row>
                    {currentCards.map((card) => (
                        <Col md={6} className="mb-4" key={card.id}>
                            <Card className="bg-dark text-light radius-15">
                                <Card.Body>
                                    <Card.Title className="text-center">{card.name}</Card.Title>
                                    <hr className="text-light" />
                                    <Row>
                                        <Col md={4}>
                                            <Card.Img src={card.logo} alt={card.name} className="img-fluid radius-15 mb-2 mr-3" />
                                        </Col>
                                        <Col md={8}>
                                            <p className="card-text">{card.description}</p>
                                            {card.category && <p><strong>Category:</strong> {card.category}</p>}
                                            {card.address && <p><strong>Address:</strong> {card.address}</p>}
                                            {card.phone && <p><strong>Phone:</strong> {card.phone}</p>}
                                            {card.email && <p><strong>Email:</strong> {card.email}</p>}
                                            <div>{card.links.map((link, index) => (
                                                <a key={index} href={link.href} target="_blank" rel="noopener noreferrer" className="btn btn-secondary m-1">{link.text}</a>
                                            ))}</div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>

                {/* Pagination */}
                <nav>
                    <ul className="pagination justify-content-center">
                        {Array(Math.ceil(filteredCards.length / cardsPerPage))
                            .fill()
                            .map((_, index) => (
                                <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                    <Button onClick={() => paginate(index + 1)} className="page-link">
                                        {index + 1}
                                    </Button>
                                </li>
                            ))}
                    </ul>
                </nav>
            </Card.Body>
        </Card>
    );
};

export default Cards;
